exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.cat-name {\n  color: #409EFF;\n}\n.el-tag {\n  margin: 5px;\n}\n.banner-img {\n  max-width: 100px;\n}\n", ""]);

// exports
